<template>
<kt-panel class="z-depth-0 bg-transparent m-0">
    <kt-panel-header class="border-0 p-0">
        <kt-panel-header-actions :style="headerAction">
            <slot></slot>
        </kt-panel-header-actions>
    </kt-panel-header>
</kt-panel>
</template>

<script>
export default {
    props: {
        headerAction: {
            default() {
                return {
                    left: '0',
                    top: '10px',
                    position: 'absolute'
                }
            },
        }
    },
}
</script>

<style>

</style>